import { useNavigate, useLocation } from 'react-router-dom';
import { BlueprintCreateForm } from '@/components/blueprint/BlueprintCreateForm';
import { useOrgRoutes } from '@/lib/useOrgRoutes';
import type { Blueprint } from '@/lib/types';

/**
 * The blueprint create form rendered as the detail panel of
 * {@link BlueprintsPage} when in `create` mode (route `blueprints/new`), so the
 * blueprint list stays visible on the left and create reads as just another
 * detail view. `location.state.clone` (from Clone/Edit) opens the full custom
 * editor pre-filled from an existing blueprint.
 *
 * The card chrome lives here rather than in the form, so a host that already
 * has a surface of its own (`BlueprintCreateDialog`) supplies none.
 */
export function BlueprintCreatePanel() {
  const navigate = useNavigate();
  const location = useLocation();
  const routes = useOrgRoutes();
  const routeState = location.state as { clone?: Blueprint } | null;
  const backToList = () => navigate(routes.blueprints);

  return (
    <div className="flex h-full flex-col items-center overflow-hidden p-4 md:p-6">
      <BlueprintCreateForm
        cloneSource={routeState?.clone}
        className="max-w-2xl rounded-xl border border-border bg-card shadow-lg"
        onCancel={backToList}
        onCreated={backToList}
      />
    </div>
  );
}
